import { createContext, useContext, useMemo, useState } from 'react';

import { useReview } from 'hooks/useReview';
import Authorization from 'models/reviews/Authorization';
import { authorizationQueryKeys, authorizationQueryParams } from 'services/api/reviews';

type AuthorizationContextType = {
  authorization: Authorization | undefined;
  setAuthorizationId: (authorizationId: string) => void;
};

export const AuthorizationContext = createContext<AuthorizationContextType>({
  authorization: undefined,
  setAuthorizationId: () => {},
});

export function AuthorizationProvider({ children }: { children: React.ReactNode }) {
  const [authorizationId, setAuthorizationId] = useState<string>('');

  const { review } = useReview(authorizationId, authorizationQueryKeys, authorizationQueryParams);

  const value = useMemo(
    () => ({
      authorization: review as Authorization | undefined,
      setAuthorizationId,
    }),
    [review]
  );

  return <AuthorizationContext value={value}>{children}</AuthorizationContext>;
}

export function useAuthorization() {
  const context = useContext(AuthorizationContext);
  if (!context) {
    throw new Error('useAuthorization must be used within an AuthorizationProvider');
  }
  return context;
}
